<template>
  <div class="home-body">
    <BlogList></BlogList>
    <div class="xs-pb-30 container">

      <HorizontalAd :containerClass="''"></HorizontalAd>
    </div>
  </div>

</template>


<script>
import _ from 'underscore'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import BlogList from '../blog/BlogList'
  import HorizontalAd from '../shared/ads/HorizontalAd'
  import VerticalAd from '../shared/ads/VerticalAd'

export default {
    components: {
      BlogList,
      HorizontalAd,
      VerticalAd
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body {background:#FFFFFF;}
</style>



// WEBPACK FOOTER //
// BlogPage.vue?20d747ea